export default __webpack_public_path__ + "static/media/05_photo.580ed5a4.jpg";